import type { ComputeHost } from './host';
import { createComputeRoutes } from './route';
import { serviceScopes } from './service';
import { workspaceService } from './workspace-service';

/**
 * The module for the app to mount: its services-hub route, catalog scopes and the loaders of the two
 * things pages render outside the console (the activation landing of the catalog detail page and the
 * full-window instance console popup), and its workspace adapter (how the registry lists and opens an
 * organization's Compute workspace). Plain data and functions; the console stays a lazy chunk
 * behind `route.ts`. The host is a lazy factory, not a value: the app file that builds it imports
 * hooks the entry chunk does not need, so it is fetched when a route (or a loader) runs and
 * registered before any code of the console runs. Taking it is the only way to get the routes, so
 * the app cannot mount the module and forget what it reads.
 */
export function createComputeModule(loadHost: () => Promise<ComputeHost>) {
  const routes = createComputeRoutes(loadHost);
  return {
    servicesRoutes: routes.servicesRoutes,
    loadActivateLanding: routes.loadActivateLanding,
    loadInstanceConsole: routes.loadInstanceConsole,
    serviceScopes,
    workspaceService,
  };
}

export type { ComputeHost } from './host';
